import React from "react";

export default function Variants() {
  return (
    <div className="flex justify-center xl:flex-row flex-col items-center gap-[100px] xl:gap-0">
      <div className="w-[545px] h-[801px] bg-variant1 bg-cover relative rounded-[32px]">
        <h2 className="text-[#3C6772] text-[64px] font-about float-right">
          Variant 1
        </h2>
        <div className="pt-[200px]">
          <div className="bg-variant1img bg-cover absolute w-[545px] h-[525px] bottom-[0] px-[32px] rounded-[32px]">
            <div className="absolute bottom-[15%] w-[80%]">
              <div className="flex items-center pb-[24px]">
                <div className="bg-[#FFFFFF] w-[24px] h-[24px] rounded-[12px] mr-[24px] absolute" />
                <p className="text-[#FFFFFF] text-[20px] font-main ml-[80px]">
                  Create one-of-a-kind, personalized storybooks tailored to your
                  interests and preferences with our AI-powered creator.
                </p>
              </div>
              <div className="flex items-center pb-[24px]">
                <div className="bg-[#FFFFFF] w-[24px] h-[24px] rounded-[12px] mr-[24px] absolute" />
                <p className="text-[#FFFFFF] text-[20px] font-main ml-[80px]">
                  Choose from a wide variety of genres and themes for endless
                  story possibilities.
                </p>
              </div>
              <div className="flex items-center pb-[24px]">
                <div className="bg-[#FFFFFF] w-[24px] h-[24px] rounded-[12px] mr-[24px] absolute" />
                <p className="text-[#FFFFFF] text-[20px] font-main ml-[80px]">
                  High-quality printing for beautiful, durable keepsakes.
                </p>
              </div>
              <div className="flex items-center pb-[24px]">
                <div className="bg-[#FFFFFF] w-[24px] h-[24px] rounded-[12px] mr-[24px] absolute" />
                <p className="text-[#FFFFFF] text-[20px] font-main ml-[80px]">
                  Convenient online creation and delivery to your doorstep.
                </p>
              </div>
              <div className="flex items-center pb-[24px]">
                <div className="bg-[#FFFFFF] w-[24px] h-[24px] rounded-[12px] mr-[24px] absolute" />
                <p className="text-[#FFFFFF] text-[20px] font-main ml-[80px]">
                  Dedicated customer service team to assist with any questions
                  or concerns.
                </p>
              </div>
              <div className="flex items-center pb-[24px]">
                <div className="bg-[#FFFFFF] w-[24px] h-[24px] rounded-[12px] mr-[24px] absolute" />
                <p className="text-[#FFFFFF] text-[20px] font-main ml-[80px]">
                  Affordable prices to make personalized storybooks accessible
                  to everyone.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className=" xl:ml-[64px]  ml-[0px]">
        <div className="w-[545px] h-[801px] bg-variant2 bg-cover relative rounded-[32px]">
          <h2 className="text-[#3C6772] text-[64px] font-about">Variant 2</h2>
          <div className="pt-[200px]">
            <div className="bg-variant2img bg-cover absolute w-[545px] h-[413px] bottom-[0] px-[32px] rounded-[32px]">
              <div className="absolute bottom-[55%] w-[80%]">
                <div className="flex items-center pb-[24px]">
                  <div className="bg-[#FFFFFF] w-[24px] h-[24px] rounded-[12px] mr-[24px] absolute" />
                  <p className="text-[#FFFFFF] text-[20px] font-main ml-[80px]">
                    Be the hero of your own adventure
                  </p>
                </div>
                <div className="flex items-center pb-[24px]">
                  <div className="bg-[#FFFFFF] w-[24px] h-[24px] rounded-[12px] mr-[24px] absolute" />
                  <p className="text-[#FFFFFF] text-[20px] font-main ml-[80px]">
                    Create your own custom storybook
                  </p>
                </div>
                <div className="flex items-center pb-[24px]">
                  <div className="bg-[#FFFFFF] w-[24px] h-[24px] rounded-[12px] mr-[24px] absolute" />
                  <p className="text-[#FFFFFF] text-[20px] font-main ml-[80px]">
                    Use AI to generate personalised fiction
                  </p>
                </div>
                <div className="flex items-center pb-[24px]">
                  <div className="bg-[#FFFFFF] w-[24px] h-[24px] rounded-[12px] mr-[24px] absolute" />
                  <p className="text-[#FFFFFF] text-[20px] font-main ml-[80px]">
                    Main character based on your photos
                  </p>
                </div>
                <div className="flex items-center pb-[24px]">
                  <div className="bg-[#FFFFFF] w-[24px] h-[24px] rounded-[12px] mr-[24px] absolute" />
                  <p className="text-[#FFFFFF] text-[20px] font-main ml-[80px]">
                    Customise the design and layout of your book
                  </p>
                </div>
                <div className="flex items-center pb-[24px]">
                  <div className="bg-[#FFFFFF] w-[24px] h-[24px] rounded-[12px] mr-[24px] absolute" />
                  <p className="text-[#FFFFFF] text-[20px] font-main ml-[80px]">
                    Order a physical print of your creation
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
